import { makeOracle } from 'apprise-core/authz'
import { User } from 'apprise-core/user'
import { useLogin } from 'apprise-frontend-iam/login/logged'






// answers questions about some target user.
// the user may be provided immediately, if it's known from the context.
// or it may be provided lazily, using the api itself (cf. given()).
// if it isn't provided at all, the api fallbacks to the logged user.

export const useOracle = (user?:User) => {

    // provides access to the logged user as required 
    // (can't useLogged() directly, may be called before logins).
    const login = useLogin()

    // returns the api for a target user. invoked immediately with the input user, if it exists.
    // may also be called from the api itself (cf.given()), to target different users on demand.
    const apiFor = (user?: User) => {

        // used internally to abstract over the target user, 
        // so that it can access the logged user lazily as a fallback.
        const current = () => user ?? login.logged()

        const self = {

            // re-targets the api to another user (eg. use in loops over users).
            given: (user?: User) => makeOracle().given(user ?? login.logged())
            
            ,

            ...makeOracle().given(current())


        }

        return self


    }

    return apiFor(user)


}